import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UserTermsConditionsComponent } from 'app/account/user-settings/user-terms-conditions/user-terms-conditions.component';

@Component({
  selector: 'upsc-terms-conditions-dialog',
  templateUrl: './terms-conditions-dialog.component.html',
  styleUrls: ['./terms-conditions-dialog.component.scss']
})
export class TermsConditionsDialogComponent implements OnInit {
  
  constructor(
    public dialogRef: MatDialogRef<TermsConditionsDialogComponent>,
    private dialog: MatDialog,
    ) { }

  ngOnInit(): void {
  }

  public close(){
    this.dialogRef.close();
  }

  public openTermsAndConditionsDialog(event) {
    event.preventDefault();

    const dialogConfig: MatDialogConfig = {
        disableClose: true,
        width: '60%',
        data: {},
    };

    let dialogRef: MatDialogRef<UserTermsConditionsComponent>;
    dialogRef = this.dialog.open(UserTermsConditionsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
    });
}
}
